import { Message } from '@dinosband/bv-messenger-schema'
import { filterOutInvalidMessages } from '@dinosband/bv-data-center'
import { CachedMessage, cidRange } from './util'
import { _first, _last } from '@dinosband/dbi-utils'
import { dataCenter } from '../../'

export async function loadRootMessageCache () {
  const rootMessageCache = (await import('@dinosband/bv-cache'))?.rootMessageCache
  rootMessageCache.load()
}

export async function getCacheChunk (chatRoomId: number, startSeq: number, size: number, excludeDeleted?: boolean) {
  const cache = (await import('@dinosband/bv-cache'))?.messageCache
  const contents = await cache.contents(chatRoomId)
  const start = contents.find((i) => i.seq === startSeq)
  if (!start) {
    return []
  }
  const lastUpdatedAt = lastUpdatedMessage(chatRoomId)?.updatedAt
  if (lastUpdatedAt) {
    if (start.createdAt < lastUpdatedAt) {
      return []
    }
  }
  const messages = contents.filter((i) => startSeq <= i.seq && i.seq < startSeq + size)
  messages.sort((a, b) => a.seq - b.seq)
  let next = startSeq
  const result: Message[] = []
  for (const i of messages) {
    if (next != i.seq) {
      break
    }
    result.push(i)
    next += 1
  }
  return filterOutInvalidMessages(result, excludeDeleted)
}

export async function getFilteredCacheChunk (chatRoomId: number, direction: 'recent' | 'before' | 'after' | 'around',
                                             seq: number, size: number, excludeDeleted?: boolean) {
  const cache = (await import('@dinosband/bv-cache'))?.messageCache
  const contents = await cache.contents(chatRoomId) as unknown as CachedMessage[]
  let result: Message[] = []
  if (direction === 'recent') {
    result = await getFilteredRecentChunk(chatRoomId, contents, size)
  } else {
    const ref = contents.find((i) => i.seq === seq)
    if (!ref || ref._cid == undefined) {
      return []
    }
    const [min, max] = cidRange(direction, ref._cid, size)
    const messages = contents.filter((i) => {
      const cid = i._cid
      return cid != undefined && min <= cid && cid <= max
    })
    messages.sort((a, b) => a.seq - b.seq)
    let next = _first(messages)?._cid
    if (next == undefined) {
      return []
    }
    for (const i of messages) {
      if (next != i._cid) {
        break
      }
      result.push(i)
      next += 1
    }
  }
  const lastUpdatedAt = lastUpdatedMessage(chatRoomId)?.updatedAt
  if (lastUpdatedAt) {
    const first = _first(result)
    if (first && first.createdAt < lastUpdatedAt) {
      return []
    }
  }
  return filterOutInvalidMessages(result, excludeDeleted)
}

async function getFilteredRecentChunk (chatRoomId: number, contents: CachedMessage[], size: number) {
  const messages = contents.filter((i) => i._cid != undefined)
  messages.sort((a, b) => a.seq - b.seq)
  if (messages.length < size && _first(messages)?.seq != 1) {
    return []
  }
  let next = _last(messages)?._cid
  if (next == undefined) {
    return []
  }
  let count = 0
  const result: CachedMessage[] = []
  for (const i of [...messages].reverse()) {
    if (next != i._cid) {
      break
    }
    result.push(i)
    next -= 1
    if (size <= ++count) {
      break
    }
  }
  result.reverse()
  if (result.length < size && _first(result)?.seq != 1) {
    //   result.map((i) => i.seq),
    //   messages.map((i) => i._cid),
    //   contents.map((i) => i._cid))
    return []
  }
  //   result.map((i) => i.seq),
  //   messages.map((i) => i._cid),
  //   contents.map((i) => i._cid))
  return result
}

function lastUpdatedMessage (chatRoomId: number) {
  return dataCenter.messages.lastUpdatedMessage(chatRoomId)
}